import axios from 'axios'

export default {
    namespaced: true,
    state: {
        settings: {},
        loadingSettings: false,
    },
    mutations: {
        SET_SETTINGS(state, settings) {
            state.settings = settings;
        },
        SET_DEFAULT_TEXT_MESSAGE(state, text_message) {
            state.settings.default_text_message = text_message;
        },
        SET_DEFAULT_VOICE_MAIL(state, voice_mail) {
            state.settings.default_voice_mail = voice_mail;
        },
        SET_LOADING_SETTINGS(state, loading) {
            state.loadingSettings = loading;
        }
    },
    getters: {
        settings: state => state.settings,
        loadingSettings: state => state.loadingSettings,
    },
    actions: {
        loadSetting({ commit }) {
            commit("SET_LOADING_SETTINGS", true);
            axios.get("/settings/get")
                .then((res) => {
                    commit("SET_SETTINGS", res.data.settings);
                })
                .catch((err) => {

                    console.log(err);
                });
            commit("SET_LOADING_SETTINGS", false);
        }
    },
}
